import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { RentalReportFilterModel } from 'src/app/models/rental/rental-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { GroupService } from 'src/app/services/archive/group.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { SubgroupService } from 'src/app/services/archive/subgroup.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { RentalReportService } from 'src/app/services/rental/rental-report.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-balances-shop',
  templateUrl: './balances-shop.component.html',
  styleUrls: ['./balances-shop.component.scss'],
  standalone: false
})
export class BalancesShopComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredStores: any[] = [];
  filteredSubgroups: any[] = [];
  formRentalReportFilter: FormGroup = new FormGroup({});
  listArticle: any[] = [];
  listBranch: any[] = [];
  listGroup: any[] = [];
  listInventory: any[] = [];
  listReportType: CustomListDropdown[] = [{ label: 'Peso', value: 1 }, { label: 'Costo Promedio', value: 2 },
  { label: 'Saldo Final(Consolidado)', value: 3 }, { label: 'Saldo Final(Por Bodega)', value: 4 }];
  listStore: any[] = [];
  listSubgroup: any[] = [];
  nameWindow: string = 'Informe de Saldos en Almacén';
  projectName = ProjectName.projectName;

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private groupService: GroupService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private rentalPeriodService: RentalPeriodService,
    private rentalReportService: RentalReportService,
    private storeService: StoreService,
    private subgroupService: SubgroupService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.getFirstBranchByUserAuthenticatedAsync();
    await this.getAllLists();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeArticle(articleId: number | null) {
    if (articleId === 0 || articleId === null || articleId === undefined) {
      this.formRentalReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  changeGroup(groupId: number | null) {
    this.filterSubgroupByGroupId(groupId);
    if (groupId != 0 && groupId != null) {
      this.formRentalReportFilter.controls["subgroupId"].patchValue(0);
    } else {
      this.formRentalReportFilter.controls["subgroupId"].patchValue(0);
      this.formRentalReportFilter.controls["groupId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeInventory(inventoryId: number | null) {
    this.filterStoreByInventoryId(inventoryId);
    if (inventoryId != 0 && inventoryId != null) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    } else {
      this.formRentalReportFilter.controls["inventoryId"].patchValue(0);
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeReportType(reportType: number) {
    if (reportType === 3) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
      this.formRentalReportFilter.controls["inventoryId"].patchValue(0);
      setTimeout(() => this.formControlStateService.setControlState(this.formRentalReportFilter, ['storeId', 'inventoryId'], false));
    } else {
      setTimeout(() => this.formControlStateService.setControlState(this.formRentalReportFilter, ['storeId', 'inventoryId'], true));
    }
    this.changeFilter();
  }

  changeStore(storeId: number | null) {
    if (storeId === 0 || storeId === null || storeId === undefined) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeSubgroup(subgroupId: number | null) {
    if (subgroupId != 0 && subgroupId != null) {
      const groupId = this.listSubgroup.find(x => x.value === subgroupId)!.groupId;
      this.formRentalReportFilter.controls["groupId"].patchValue(groupId);
      this.filterSubgroupByGroupId(groupId);
    } else {
      this.formRentalReportFilter.controls["subgroupId"].patchValue(0);
    }
    this.changeFilter();
  }

  clear() {
    this.changeFilter();
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const dateInitial = this.formRentalReportFilter.controls['dateInitial'].value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);

      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      modelRentalReportFilter.year = parseInt(year);
      modelRentalReportFilter.period = parseInt(period);
      modelRentalReportFilter.byStores = true;
      if (this.formRentalReportFilter.get("typeReport")?.value === 3) {
        modelRentalReportFilter.byStores = false;
      }
      try {
        const typeReportValue = this.formRentalReportFilter.get("typeReport")?.value;
        let reportSuffix = '';
        switch (typeReportValue) {
          case 1:
            reportSuffix = 'Peso';
            break;
          case 2:
            reportSuffix = 'Costo Promedio';
            break;
          case 3:
            reportSuffix = 'Saldo Final (Consolidado)';
            break;
          case 4:
            reportSuffix = 'Saldo Final (Por Bodega)';
            break;
          default:
            reportSuffix = 'General';
            break;
        }
        const fileName = `Informe de Saldos en Almacén - ${reportSuffix}.xlsx`;

        const response = await firstValueFrom(this.rentalReportService.exportRentalReportBalancesShop(modelRentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterStoreByInventoryId(inventoryId: number | null) {
    const rowsFiltered = this.listStore.filter(x => x.inventoryId === inventoryId);
    if (inventoryId != null) {
      this.filteredStores = rowsFiltered;
    } else {
      this.filteredStores = this.listStore;
    }
    this.formRentalReportFilter.controls["storeId"].patchValue(0);
  }

  filterSubgroupByGroupId(groupId: number | null) {
    const rowsFiltered = this.listSubgroup.filter(x => x.groupId === groupId);
    if (groupId != null) {
      this.filteredSubgroups = rowsFiltered;
      const subgroupId = this.formRentalReportFilter.get("subgroupId")?.value;
      const subgroupExists = this.listSubgroup.some(x => x.groupId === groupId && x.value === subgroupId);

      if (subgroupId && !subgroupExists) {
        this.formRentalReportFilter.controls["subgroupId"].patchValue(0);
      }
    } else {
      this.filteredSubgroups = this.listSubgroup;
    }
  }

  async getAllLists() {
    try {
      const [articles, branches, inventories, groups, subgroups, stores] = await Promise.all([
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.inventoryService.getAllInventoriesForSelectReportAsync()),
        firstValueFrom(this.groupService.getAllGroupsForSelectAsync()),
        firstValueFrom(this.subgroupService.getAllSubgroupsForSelectAsync()),
        firstValueFrom(this.storeService.getAllStoresForSelectAsync())
      ]);
      this.listArticle = articles;
      this.listBranch = branches;
      this.listInventory = inventories;
      this.listGroup = groups;
      this.listSubgroup = subgroups;
      this.filteredSubgroups = this.listSubgroup;
      this.listStore = stores;
      this.filteredStores = this.listStore;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formRentalReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.getLastRentalPeriod(branch.branchId);
      this.filteredStores = this.listStore;
      this.filteredSubgroups = this.listSubgroup;
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formRentalReportFilter.controls["dateInitial"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
    } catch (error) {
      console.error("Error al consultar el periodo de alquiler:", error);
    }
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formRentalReportFilter.controls).forEach(key => {
      const control = this.formRentalReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formRentalReportFilter.valid) {
      const dateInitial = this.formRentalReportFilter.get("dateInitial")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);

      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      modelRentalReportFilter.year = parseInt(year);
      modelRentalReportFilter.period = parseInt(period);
      modelRentalReportFilter.byStores = true;
      if (this.formRentalReportFilter.get("typeReport")?.value === 3) {
        modelRentalReportFilter.byStores = false;
      }

      try {
        this.dataReport = await firstValueFrom(this.rentalReportService.rentalReportBalancesShop(modelRentalReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      typeReport: {
        required: 'El campo Tipo Informe es obligatorio.',
        min: 'Debe seleccionar un Tipo Informe válido.'
      },
      dateInitial: {
        required: 'El campo Período es obligatorio.'
      },
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      groupId: {
        notNumber: 'Debe seleccionar un Grupo válido.'
      },
      subgroupId: {
        notNumber: 'Debe seleccionar un Subgrupo válido.'
      },
      articleId: {
        notNumber: 'Debe seleccionar un Artículo válido.'
      },
      storeId: {
        notNumber: 'Debe seleccionar una Bodega válida.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formRentalReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formRentalReportFilter = this.formBuilder.group({
      typeReport: [1, [Validators.required]],
      dateInitial: ['', [Validators.required]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      groupId: [0, [CustomValidators.numberOnlyValidator()]],
      subgroupId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]],
      inventoryId: [0],
      storeId: [0, [CustomValidators.numberOnlyValidator()]],
      articleName: [""]
    });
  }

}
